import React from "react";

const CardSecondary = (props) => {
  const { img, alt, text, active, onClick } = props;
  return (
    <div className={`card-secondary ${active ? "card-secondary-active" : ""}`} onClick={onClick}>
      <div className="img">
        <img src={img} alt={alt} />
        <div className="bg-dark">
          <p>{text}</p>
        </div>
      </div>
    </div>
  );
};

export default CardSecondary;
